"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginPage = exports.LoginPageConfig = void 0;
const centered_card_1 = require("../../components/centered.card/centered.card");
const login_1 = require("../../modules/auth/login");
const index_1 = require("../../services/index");
const page_1 = require("../page");
exports.LoginPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.login,
    path: '/login',
    auth: { required: false },
    layout: { nav: false, banner: false },
};
class LoginPage extends page_1.IkePage {
    constructor(redirectURL) {
        super(exports.LoginPageConfig);
        this.name = 'Login';
        this.redirectURL = redirectURL || index_1.Services.Route.getRouteURL(page_1.IkePageName.map);
        this.component = new login_1.SSOLoginComponent();
        this.reaction(() => index_1.Services.User.current, (user) => this.checkLoggedIn(user), { fireImmediately: true });
    }
    get nodes() {
        return centered_card_1.CenteredCard.view(this.component.view());
    }
    enterSite() {
        index_1.Services.Route.goRaw(this.redirectURL);
    }
    checkLoggedIn(user) {
        if (user != null) {
            this.enterSite();
        }
    }
}
exports.LoginPage = LoginPage;
//# sourceMappingURL=login.page.js.map